import { render } from "./np-questionnaire.vue?vue&type=template&id=0388442c&scoped=true"
import script from "./np-questionnaire.vue?vue&type=script&lang=js"
export * from "./np-questionnaire.vue?vue&type=script&lang=js"

import "./np-questionnaire.vue?vue&type=style&index=0&id=0388442c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0388442c"]])

export default __exports__